
















































































































import {
  apiCollectionCommodityCancel,
  apiCollectionCommodityList,
  apiShoppingCartAdd,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { Dialog } from 'vant'
import { navigateTo } from '@/router'
import { submit, UniGoods } from '@/utils'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  () =>
    class {
      waterfall = useWaterfall('list')

      isEdit = ref(false)

      goodsData = ref<UniGoods[]>([])

      goodsSelectedMap = ref<Record<string, boolean>>({})

      selectedGoods = computed(() =>
        this.goodsData.value.filter(
          item => !!this.goodsSelectedMap.value[item.id],
        ),
      )

      allSelected = computed<boolean>({
        get: () =>
          this.selectedGoods.value.length === this.goodsData.value.length,
        set: value =>
          (this.goodsSelectedMap.value = value
            ? this.goodsData.value.reduce<Record<string, boolean>>(
                (res, item) => {
                  res[item.id] = true
                  return res
                },
                {},
              )
            : {}),
      })

      loadData: XWaterfallLoad = ({ pageNumber }) =>
        apiCollectionCommodityList({
          pageIndex: pageNumber,
          pageSize: 10,
        }) as any

      handleBackHomeClick = () => {
        navigateTo('HomeIndex')
      }

      handleGoodsClick = (item: UniGoods) => {
        if (this.isEdit.value) {
          this.goodsSelectedMap.value = {
            ...this.goodsSelectedMap.value,
            [item.id]: !this.goodsSelectedMap.value[item.id],
          }
        } else {
          navigateTo('GoodsIndex', { id: item.id })
        }
      }

      handleCartClick = (item: UniGoods) => {
        submit(async $ => {
          $.start('加入购物车中...')
          await apiShoppingCartAdd({
            commodityId: item.id,
            quantity: 1,
            skuId: item.raw.skuId,
          })
          await $.success('加入购物车成功')
        })
      }

      handleCancelClick = () => {
        submit(async $ => {
          const selectedGoods = this.selectedGoods.value
          if (!selectedGoods.length) {
            return $.fail('请先选择商品')
          }
          await Dialog.confirm({
            title: '确认取消收藏已选择的商品？',
            confirmButtonText: '确认',
            cancelButtonText: '再想想',
          })
          $.start('取消收藏中...')
          await apiCollectionCommodityCancel({
            skuIdList: selectedGoods.map(item => item.raw.skuId),
          })
          await this.waterfall.reload()
          await $.success('取消收藏成功')
        })
      }
    },
)
